import Icon from '@/components/ui/AppIcon';

interface PerformanceMetricCardProps {
  title: string;
  value: string;
  change: number;
  trend: 'up' | 'down' | 'stable';
  icon: string;
  description: string;
}

export default function PerformanceMetricCard({
  title,
  value,
  change,
  trend,
  icon,
  description
}: PerformanceMetricCardProps) {
  const trendConfig = {
    up: { color: 'text-success', icon: 'ArrowTrendingUpIcon', label: 'increase' },
    down: { color: 'text-error', icon: 'ArrowTrendingDownIcon', label: 'decrease' },
    stable: { color: 'text-muted-foreground', icon: 'MinusIcon', label: 'stable' }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 hover:shadow-lg transition-all duration-base">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name={icon as any} size={24} variant="outline" className="text-primary" />
        </div>
        <div className={`flex items-center space-x-1 px-2 py-1 rounded-md ${trend === 'up' ? 'bg-success/10' : trend === 'down' ? 'bg-error/10' : 'bg-muted'}`}>
          <Icon name={trendConfig[trend].icon as any} size={14} variant="outline" className={trendConfig[trend].color} />
          <span className={`text-xs font-cta font-bold ${trendConfig[trend].color}`}>
            {Math.abs(change)}%
          </span>
        </div>
      </div>
      
      <h3 className="text-sm font-body text-muted-foreground mb-1">{title}</h3>
      <p className="text-3xl font-headline font-bold text-foreground mb-2">{value}</p>
      <p className="text-xs font-body text-muted-foreground">{description}</p>
    </div>
  );
}